import dataService from "@/services/dataService";
import axios from 'axios';

export default {
  state: () => ({
    uploadMessage: '',
    userFiles: [],
    uploadingFiles: [],
  }),
  mutations: {
    setUploadMessage(state, message) {
      state.uploadMessage = message;
    },
    setUserFiles(state, files) {
      state.userFiles = files;
    },
    setUploadingFiles(state, files) {
      state.uploadingFiles = files;
    },
    updateFileProgress(state, { fileName, progress }) {
      const file = state.uploadingFiles.find((f) => f.name === fileName);
      if (file) {
        file.progress = progress;
      }
    },
  },
  actions: {
    async uploadFileToGCP({ commit, state }, files) {
      // Initialize uploadingFiles with progress
      const fileArray = [...files];

      commit('setUploadingFiles', fileArray);

      // Upload each file
      const uploadPromises = state.uploadingFiles.map(async (file) => {
        try {
          const { url, filePath } = await dataService.getGCPFileUrl(file);

          // Upload file with progress tracking
          await axios.put(url, file, {
            headers: {
              'Content-Type': file.type,
            },
            onUploadProgress: (progressEvent) => {
              const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
              commit('updateFileProgress', { fileName: file.name, progress });
            },
          });

          // Save file metadata to the database
          await dataService.saveFileToDb({
            file_name: file.name,
            file_path: filePath,
            content_type: file.type,
            file_size: file.size,
          });
        } catch (error) {
          commit('setUploadMessage', `Error uploading ${file.name}: ${error.message}`);
          throw error;
        }
      });

      // Wait for all uploads to complete
      await Promise.all(uploadPromises);

      commit('setUploadMessage', 'All files uploaded successfully!');
    },
    async fetchUserFiles({ commit }) {
      let userFiles = await dataService.fetchUserFiles();
      commit('setUserFiles', userFiles);
    },
  },
  getters: {
    userFiles: (state) => state.userFiles,
    uploadingFiles: (state) => state.uploadingFiles
  },
};
